import React, { ReactNode } from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'
import { Button, Page } from '../../../components'
import { images } from '../../../images'
import { AuthenticatedRoutable } from '../../../models'
import { urls } from '../../../routing'
import literalsService from '../../../services/literals-service'
import StyledArticle from './styles'
import { appsStyleSelected } from '../../../helpers/app'

interface IProps extends RouteComponentProps {
  dispatch: any
}

class ComplaintsAndSuggestionsDone extends AuthenticatedRoutable<IProps> {
  public render(): ReactNode {
    const objectLost = !!this.props.location.state?.objectLost

    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            <img src={ images['check'] } className="check" alt="" />
            <h3>{ literalsService.get(objectLost ? 'objectsLost' : 'complaintsAndSuggestions', true) }</h3>
            <p>{ literalsService.get('thanksForComments') }</p>
            <p>{ literalsService.get('weWillCheckLater') }</p>
            <Button
              title={ literalsService.get('accept', true) }
              onPress={ this.goToConfiguration }
              className="acceptButton"
              filled
              upper
            />
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private goToConfiguration = () => {
    this.props.history.push(urls.config)
  }
}

export default withRouter(connect()(ComplaintsAndSuggestionsDone))
